import { useCallback, useContext, useEffect } from 'react';
import { UnsavedChangesContext } from '../components/UnsavedChangesProvider';
const useUnsavedChangesRegistration = (token, dirty, saving = false) => {
    const { register, unregister } = useContext(UnsavedChangesContext);
    useEffect(() => {
        register(token, dirty, saving);
        return () => unregister(token);
    }, [token, dirty, saving, register, unregister]);
    return useCallback(() => unregister(token), [token, unregister]);
};
export default useUnsavedChangesRegistration;
